/** Tage im aktuellen Status (seit letztem Statuswechsel oder seit Anlage). */
export function getDaysInCurrentStatus(lead) {
  const raw = lead?._statusChangedAt || lead?.createdAt;
  if (!raw) return null;
  const start = new Date(raw);
  if (Number.isNaN(start.getTime())) return null;
  return Math.floor((Date.now() - start.getTime()) / 86400000);
}

/** >14 Tage warn, >30 kritisch (Farben für Light/Dark via CSS-Variablen wo möglich). */
export function getStatusAgeStyle(days) {
  if (days == null) {
    return { tier: 'unknown', bar: 'var(--bg4)', text: 'var(--text3)', label: '–' };
  }
  if (days > 30) {
    return { tier: 'critical', bar: '#dc2626', text: '#dc2626', label: `${days} T.` };
  }
  if (days > 14) {
    return { tier: 'warn', bar: '#ca8a04', text: '#a16207', label: `${days} T.` };
  }
  return { tier: 'ok', bar: '#22c55e', text: 'var(--text2)', label: `${days} T.` };
}
